<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

      <a style="float:right" href="http://www.goweb.guru">GoWeb.guru</a>

    </div>

</mat-toolbar>
